/**
 * This legacy code has been transfferred from js/comments.js
 * when the comments were rewritten on Vue
 */

const htmlToMarkdown = html => {
	var $wrap = $('<div class="entry-wrap" />');
	$wrap.append(html);

	// Replace <div class="code"><pre>code here ... </pre></div> tags with <code>code here ... </code>
	$wrap.find('.code pre').each(function () {
		$(this).replaceWith('<code>' + this.innerHTML + '</code>');
	});

	$wrap.find('.quotes').each(function() {
		var $quote = $(this);
		var $replaced = $('<blockquote />');
		$replaced.html($quote.html().replace('&gt;&gt; ', ''));
		$quote.after($replaced);
		$quote.remove();
	});

	// Remove quotes (offers) from the copied markdown
	if($wrap.find('.quote .quote-nav a:contains(View)').length) {
		$wrap.find('.quote').replaceWith(function() {
			return '[quote @ ' + $(this).find('.quote-nav a:contains(View)')[0].href + ']';
		});
	} else {
		const title = $wrap.find('.quote-head h2').text();
		$wrap.find('.quote').replaceWith(`[quote #${title}]`);
	}

	// Remove comment reminders
	$wrap.find('.comment-reminder').contents().unwrap();

	// remove empty tags from email replies
	var possiblyEmptyElements = ['div', 'blockquote', 'p', 'span'];

	for (var i = 0; i < possiblyEmptyElements.length; i++) {
		var possiblyEmptyElement = possiblyEmptyElements[i];

		$wrap.find(possiblyEmptyElement).each(function() {
			var $possiblyEmptyElement = $(this);

			if ($.trim($possiblyEmptyElement.text()) == '' && !$possiblyEmptyElement.find('img').length) {
				$possiblyEmptyElement.remove();
			}
		});
	}

	// switch divs with text to paragraphs
	$wrap.find('div').each(function() {
		var $div = $(this);

		if(!$div.find('div').length && !$div.find('p').length && !$div.find('blockquote').length) {
			var $p = $('<p />');
			$p.html($div.html());
			$div.after($p);
			$div.remove();
		}
	});

	$wrap.find('[dir]').each(function() {
		var $elem = $(this);

		$elem.after($elem.html());
		$elem.remove();
	});

	// Get rid of useless <div> wrappers. Email clients like to add them a lot
	removeJunkTags($wrap, 'div');
	removeJunkTags($wrap, 'font');

	fixListOnlyMessage($wrap);

	return toMarkdown( $wrap.html(), {
		gfm: true,
		converters: [
			{
				filter: 'hr',
				replacement: function() {
					return '----';
				}
			}
		]
	} );
}

const removeJunkTags = function ($entry, junkSelector) {
	let $remainingJunk;

	do {
		$remainingJunk = $entry.find(junkSelector);

		// Replace the junk tag with it's direct children, and the text nodes contained in it
		const $firstJunkTag = $remainingJunk.first();
		$firstJunkTag.replaceWith($firstJunkTag.contents());
	} while ($remainingJunk.length > 1);
}

// Copying list items(<li>...</li>) only isn't handled correctly by html-to-markdown
// This function makes sure that li-only collections are wrapped correctly in an list item
const fixListOnlyMessage = $entry => {
	// do nothing if there is at least one top-level child that isn't a <li>
	if ($entry.children(':not(li)').length === 0) {
		// wrap all top-level children with a single ordered list
		$entry.children().wrapAll('<ol />')
	}
}

const selectedTextAsMarkdown = () => {
	var html = "";
	if (typeof window.getSelection != "undefined") {
		var sel = window.getSelection();
		if (sel.rangeCount) {
			var container = document.createElement("div");
			for (var i = 0, len = sel.rangeCount; i < len; ++i) {
				container.appendChild(sel.getRangeAt(i).cloneContents());
			}
			html = container.innerHTML;
		}
	} else if (typeof document.selection != "undefined") {
		if (document.selection.type == "Text") {
			html = document.selection.createRange().htmlText;
		}
	}

	return htmlToMarkdown(html);
}

export {
	htmlToMarkdown,
	selectedTextAsMarkdown
};
